module.exports = __webpack_public_path__ + "static/quiz-hero-image-feb8ade2a0d4314bc500ec68eea5866b.png";